<template>
    <v-card width="100%" class="mt-3 pt-3 pl-3 pr-3" color="#eee">
        <v-row>
            <v-col cols="12">
                <h3>{{index}}. {{question.title}}</h3>
            </v-col>
            <v-col cols="12" class="pl-3">
                <v-radio-group v-model="choice" :disabled="true">
                    <v-radio v-for="(n, idx) in question.choice" :key="idx" :label="n.title" :value="n.id"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    props:{
        index: {
            type: Number,
            default: -1,
        },
        question: {
            type: Object, 
            default: {
                id: -1,
                title: "",
                choice: []
            }
        },
        choice: {
            type: Number,
            default: -1
        }
    },
}
</script>